import { render, staticRenderFns } from "./ReviewTree.vue?vue&type=template&id=422f6878&scoped=true&"
import script from "./ReviewTree.vue?vue&type=script&lang=js&"
export * from "./ReviewTree.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTree.vue?vue&type=style&index=0&id=422f6878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f6878",
  null
  
)

export default component.exports